/**
 * Visualizes the 8-stage Markaii Loop (ADR-0014) and where the platform
 * currently sits on the automation curve per stage.
 *
 * Each card links to the screen where you act on that stage, so the panel
 * is a navigational map, not just a static legend. Per-project, data-driven
 * loop health lives on each project page (ProjectDetail → LoopStatus).
 *
 * Status legend:
 *   auto     — fully automated, no human required
 *   partial  — runs automatically but human gate involved
 *   manual   — exists but human-initiated
 *   queued   — planned, not yet implemented
 */
import { Link } from 'react-router-dom';

const STAGES = [
  { n: 1, key: 'situation',  title: 'Situation',       sub: 'Audience + brand inputs', status: 'partial', detail: 'Brand brief — set your direction.', to: '/projects' },
  { n: 2, key: 'objectives', title: 'Objectives',      sub: 'SMART KPIs',              status: 'partial', detail: 'AI targets — editable per plan.',    to: '/projects' },
  { n: 3, key: 'strategy',   title: 'Strategy',        sub: 'Pillars + cadence',       status: 'auto',    detail: 'AI Plan Generator (live).',          to: '/projects' },
  { n: 4, key: 'tactics',    title: 'Tactics',         sub: 'Per-pillar prompts',      status: 'partial', detail: 'Prompts + your pillar direction.',   to: '/projects' },
  { n: 5, key: 'generate',   title: 'Generate',        sub: 'AI drafts content',       status: 'auto',    detail: 'Cron-driven (live).',                to: '/posts' },
  { n: 6, key: 'approve',    title: 'Approve',         sub: 'Human / auto gate',       status: 'partial', detail: 'Approve / reject in the queue.',     to: '/posts?state=review' },
  { n: 7, key: 'publish',    title: 'Publish',         sub: 'Multi-platform',          status: 'auto',    detail: 'IG + LinkedIn adapters (live).',     to: '/posts?state=approved' },
  { n: 8, key: 'sense',      title: 'Sense + Iterate', sub: 'Stats + plan update',     status: 'auto',    detail: 'Ingest → analyze → optimize (live).', to: '/posts?state=published' },
];

const STATUS_LABEL = {
  auto: 'Auto',
  partial: 'Partial',
  manual: 'Manual',
  queued: 'Queued',
};

export default function PipelinePanel() {
  return (
    <section className="pipeline">
      <div className="pipeline-head">
        <h1>Markaii Loop</h1>
        <p className="pipeline-sub">
          The 8-stage marketing process from ADR-0014. Click a stage to act on it.
        </p>
      </div>

      <div className="pipeline-grid">
        {STAGES.map((s) => (
          <Link key={s.key} to={s.to} className={`pipeline-step pipeline-${s.status}`}>
            <div className="pipeline-step-head">
              <span className="pipeline-num">{s.n}</span>
              <span className={`pipeline-chip chip-${s.status}`}>{STATUS_LABEL[s.status]}</span>
            </div>
            <h3>{s.title}</h3>
            <div className="pipeline-step-sub">{s.sub}</div>
            <div className="pipeline-step-detail">{s.detail}</div>
            <span className="pipeline-step-go">Open →</span>
          </Link>
        ))}
      </div>

      <div className="pipeline-legend">
        <span><span className="chip-dot chip-dot-auto" /> Auto · no human required</span>
        <span><span className="chip-dot chip-dot-partial" /> Partial · human gate</span>
        <span><span className="chip-dot chip-dot-manual" /> Manual · human-initiated</span>
        <span><span className="chip-dot chip-dot-queued" /> Queued · not yet shipped</span>
      </div>
    </section>
  );
}
